export const COLUMN_WIDTH_REMS = 5.75;
export const FIRST_COLUMN_WIDTH_REMS = 9.5;
export const CHART_HEIGHT_REMS = 12.75;
export const DAY_COLUMN_WIDTH_REMS = 2.25;
export const TICK_EXTENSION_HEIGHT_PX = 25;
